<button [disabled]="userService.entityIsOwn(likeable)"
  (appLoginClickGuard)="toggleLike()"
  [class.liked]="likedByMe"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="5px">
  <i class="fal fa-thumbs-up"
    *ngIf="!likedByMe; else likedIcon"></i>
  <ng-template #likedIcon> <i class="fas fa-thumbs-up liked"></i></ng-template>
  <span [class.hideTextMobile]="hideTextMobile">&nbsp;Gefällt mir</span><span
    *ngIf="likeCount>0">&nbsp;({{likeCount}})</span>
</button>